module.exports = __webpack_public_path__ + "media/images/athena_logo-8ef09d37b3857c294127576bd6d1baa5.png";